import React, { Component, useCallback, useRef } from "react"
import Svg from "../_svgs/svg"
import { isMobile } from "react-device-detect"
import smoothscroll from "smoothscroll-polyfill"
import { htmlStringToReactElement } from "../../helpers/html"
import { handleMopinion } from "../../helpers/mopinionHelpers"

export default class AllowedItemsList extends Component {
  constructor(props) {
    super(props)

    const hash = decodeURIComponent(window.location.hash?.replace("#", ""))
    const searchResult = this.searchForHash(hash, props)

    smoothscroll.polyfill()

    this.state = {
      allItems: props.items,
      popularItems: props.popularItems,
      remainingItems: props.remainingItems,
      items: props.remainingItems,
      query: "",
      itemsShown: searchResult.itemsShown,
      shownItems: searchResult.shownItems,
      initialAmount: searchResult.numberOfItems,
      hash: hash || "",
      activateAutoScroll: false,
    }
  }

  componentDidMount() {
    document.addEventListener("click", (event) => {
      var target = event.target
      if (target.tagName.toLowerCase() === "a") {
        var href = target.getAttribute("href")
        var link = new URL(href, window.location.href)
        if (link.hash && link.pathname === window.location.pathname && link.origin === window.location.origin) {
          event.preventDefault()
          const hash = decodeURIComponent(link.hash.replace("#", ""))
          window.location.hash = hash
          const searchResult = this.searchForHash(hash, this.props, true)
          this.setState({
            hash: hash || "",
            itemsShown: searchResult.itemsShown,
            shownItems: searchResult.shownItems,
            initialAmount: searchResult.numberOfItems,
          })
        }
      }
    })
    handleMopinion(this.props.mopinionId)
  }

  componentDidUpdate() {
    handleMopinion(this.props.mopinionId)
  }

  searchForHash = (hash, props, update = false) => {
    const { textKeys } = props
    let numberOfItems = update ? this.state.itemsShown : isMobile ? textKeys.numberOfItemsMobile : textKeys.numberOfItems
    let shownItems = props.remainingItems?.slice(0, numberOfItems) || []
    if (hash) {
      const popularItemsIndex = this.findIndexWithProperty(props.popularItems, "anchorId", hash)
      if (popularItemsIndex < 0) {
        // look in remaining items if hash is not found in popular items
        const index = this.findIndexWithProperty(props.remainingItems, "anchorId", hash)
        if (index > -1 && index > numberOfItems) {
          numberOfItems = index + 5
          shownItems = props.remainingItems?.slice(0, numberOfItems) || []
        }
      }
    }
    return { hash: hash || "", itemsShown: numberOfItems, shownItems: shownItems, numberOfItems: numberOfItems }
  }

  findIndexWithProperty = (array, propName, propValue) => {
    for (var i = 0; i < array.length; i++) {
      if (array[i][propName] === propValue) {
        return i
      }
    }
    return -1
  }

  handleInput = (event) => {
    const name = event.target.name
    const value = event.target.value
    this.setState({ [name]: value })
    this.search(value)
  }

  search = async (query) => {
    const { textKeys } = this.props

    // reset to zero state
    if (query.length < 2) {
      const numberOfItems = isMobile ? textKeys.numberOfItemsMobile : textKeys.numberOfItems
      const shownItems = this.props.remainingItems.slice(0, numberOfItems)
      this.setState({ items: this.props.remainingItems, shownItems: shownItems, itemsShown: numberOfItems })
      return
    }

    let items = this.props.items.filter((item) => {
      let matches = []
      if (item.title) matches.push(this.isMatch(item.title, query))
      if (item.info) matches.push(this.isMatch(item.info, query))
      if (item.category) matches.push(this.isMatch(item.category, query))
      return matches.includes(true)
    })

    const numberOfItems = isMobile ? textKeys.numberOfItemsMobile : textKeys.numberOfItems
    const shownItems = items.slice(0, numberOfItems)
    this.setState({ items: items, shownItems: shownItems, itemsShown: numberOfItems })
  }

  isMatch = (text, query) => {
    const decodedText = this.decodeAndRemoveHtml(text)
    let isMatch = false
    const splitQuery = query.split(" ").filter(Boolean)
    if (splitQuery.length > 1) {
      for (var i = 0; i < splitQuery.length; i++) {
        const part = splitQuery[i]
        if (part.length < 2) continue
        isMatch = this.matchString(decodedText, part)
        if (isMatch) return isMatch
      }
    } else {
      isMatch = this.matchString(decodedText, query)
    }
    return isMatch
  }

  matchString = (text, query) => {
    return text.toLowerCase().trim().indexOf(query.toLowerCase().trim()) > -1 ? true : false
  }

  decodeAndRemoveHtml(html) {
    var txt = document.createElement("textarea")
    txt.innerHTML = html
    return txt.value.replace(/<\/?[^>]+(>|$)/g, "")
  }

  handleMoreClick = (increase) => {
    const items = this.state.items ?? []
    const newAmount = this.state.itemsShown + increase
    const shownItems = items.slice(0, newAmount)
    this.setState({ itemsShown: newAmount, shownItems: shownItems, activateAutoScroll: true }, () => {
      var elements = document.getElementsByClassName("next-items-wrapper")
      if (elements.length > 0) {
        const element = elements[0]
        element.classList.remove("open")
        element.classList.add("opening")
        setTimeout(function () {
          element.classList.remove("opening")
          element.classList.add("open")
        }, 500)
      }
    })
  }

  handleHideClick = () => {
    const { textKeys } = this.props
    const items = this.state.items ?? []
    const numberOfItems = isMobile ? textKeys.numberOfItemsMobile : textKeys.numberOfItems
    const shownItems = items.slice(0, numberOfItems)
    this.setState({ itemsShown: numberOfItems, shownItems: shownItems, activateAutoScroll: false }, () => {
      const searchField = document.getElementById("items-search-field")
      if (searchField) {
        this.scrollIntoView(searchField)
      }
    })
  }

  scrollIntoView = (element) => {
    const siteHeader = document.getElementsByClassName("site-header")[0]
    const headerOffset = siteHeader.clientHeight + 20
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
      // behavior: "smooth"
    })
  }

  setToState = (data) => {
    this.setState(data)
  }

  render() {
    const { textKeys } = this.props

    const searchBarActive = this.state.query.length > 1
    return (
      <div className={`allowed-items-list ${this.props.descriptionIcons && this.props.descriptionIcons.length > 0 ? "has-description-icons" : ""}`}>
        <div className="items-list-inner">
          {this.props.descriptionIcons && this.props.descriptionIcons.length > 0 ? (
            <div className={`icon-descriptions ${textKeys.disclaimerText ? "no-bottom-padding" : ""}`}>
              <div className="icon-descriptions-inner">
                {this.props.descriptionIcons.map((item, index) => {
                  return (
                    <div className="item" key={index}>
                      <Svg iconName={item.icon} stroke={"#FFF"} fillColor={item.iconColor} />
                      <span className="text">{item.text}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          ) : (
            ""
          )}
          {textKeys.disclaimerText ? <div className="disclaimer-box" dangerouslySetInnerHTML={{ __html: textKeys.disclaimerText }}></div> : ""}
        </div>
        <div className="items-list-wrapper">
          <div className="items-list-inner">
            <div className="form">
              <div className="form__section">
                <div className="form__section__inner">
                  <div id="items-search-field" className="search-field">
                    <input
                      className="search-input"
                      name="query"
                      type="text"
                      placeholder={textKeys.searchFieldLabel || "Søg på genstande"}
                      value={this.state.query}
                      onChange={(e) => this.handleInput(e)}
                      autoComplete="off"
                    />
                    <button
                      tabIndex={`${searchBarActive ? 0 : -1}`}
                      className={`search-button ${searchBarActive ? "active" : ""}`}
                      aria-hidden={`${searchBarActive ? "false" : "true"}`}
                      onClick={searchBarActive ? () => this.setState({ query: "" }) : undefined}
                    >
                      <div className="search-icon"></div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.query.length < 2 && this.state.popularItems && this.state.popularItems.length > 0 ? (
            <div className="most-popular-items">
              <div className="items-list-inner">
                <h2 className="items-headline">{textKeys.mostPopularHeadline || "Mest Populære"}</h2>
                {this.state.popularItems.map((item, index) => {
                  return (
                    <Item
                      key={item.info + index}
                      item={item}
                      checkinLabel={textKeys.checkinLabel || "Indtjekket"}
                      handLuggageLabel={textKeys.handLuggageLabel || "Håndbagage"}
                      scrollIntoView={this.scrollIntoView}
                      setToState={this.setToState}
                      hash={this.state.hash}
                      mopinionScript={textKeys.mopinionScript || null}
                    />
                  )
                })}
              </div>
            </div>
          ) : (
            ""
          )}
          <div id="allowed-items" className="items-list-inner padding-bottom">
            {this.state.items && this.state.items.length > 0 ? (
              <React.Fragment>
                {searchBarActive ? null : <h2 className="items-headline">{textKeys.alphabeticalHeadline || "Fra A-Z"}</h2>}
                <Items
                  items={this.state.shownItems}
                  allItems={this.state.items}
                  increaseAmount={isMobile ? textKeys.numberOfItemsIncrementMobile : textKeys.numberOfItemsIncrement}
                  initialAmount={this.state.initialAmount}
                  amountShown={this.state.itemsShown}
                  checkinLabel={textKeys.checkinLabel || "Indtjekket"}
                  handLuggageLabel={textKeys.handLuggageLabel || "Håndbagage"}
                  scrollIntoView={this.scrollIntoView}
                  setToState={this.setToState}
                  hash={this.state.hash}
                  activateAutoScroll={this.state.activateAutoScroll}
                  handleMoreClick={this.handleMoreClick}
                  mopinionScript={this.props.mopinionScript || null}
                  isMobile={isMobile}
                  numberOfItemsIncrementMobile={textKeys.numberOfItemsIncrementMobile}
                  numberOfItemsIncrement={textKeys.numberOfItemsIncrement}
                />
                <div className={`buttoncontainer ${this.state.items && this.state.items.length > textKeys.numberOfItems ? "has-button" : ""}`}>
                  {this.state.items && this.state.items.length > textKeys.numberOfItems ? (
                    <a
                      className="button button--expander"
                      onClick={() =>
                        this.state.itemsShown >= this.state.items.length
                          ? this.handleHideClick()
                          : this.handleMoreClick(isMobile ? textKeys.numberOfItemsIncrementMobile : textKeys.numberOfItemsIncrement)
                      }
                    >
                      <span className="text">
                        {this.state.itemsShown >= this.state.items.length
                          ? textKeys.showLessItemsText || "Vis færre"
                          : textKeys.showMoreItemsText || "Vis flere"}
                      </span>
                    </a>
                  ) : (
                    ""
                  )}
                </div>
              </React.Fragment>
            ) : (
              <div className="allowed-item-list__no-results">
                <div className="section-header section-header--small">
                  <p>{textKeys.noResultsText.replace("{input}", this.state.query)}</p>
                  <div>
                    <h2>{textKeys.noResultsHeader}</h2>
                    <p>{textKeys.noResultsSubHeader}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

//rewrote component to functional to make use of useCallback and useRef hooks.
const Items = ({
  allItems,
  hash,
  mopinionScript,
  handLuggageLabel,
  checkinLabel,
  scrollIntoView,
  setToState,
  amountShown,
  activateAutoScroll,
  increaseAmount,
  initialAmount,
  handleMoreClick,
  isMobile,
  numberOfItemsIncrementMobile,
  numberOfItemsIncrement,
  items,
}) => {
  const observer = useRef()
  const lastItemElement = useCallback(
    (node) => {
      if (!node || allItems.length === 0) return
      if (observer.current) observer.current.disconnect()
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && activateAutoScroll && items.length !== allItems.length) {
          handleMoreClick(isMobile ? numberOfItemsIncrementMobile : numberOfItemsIncrement)
        }
      })
      observer.current.observe(node)
    },
    [amountShown, items, activateAutoScroll],
  )

  if (allItems && allItems.length > 0) {
    const mappedItems = allItems.map((item, index) => {
      const isLastItem = items.length === index + 1
      return (
        <Item
          key={item.title + index}
          item={item}
          hash={hash}
          mopinionScript={mopinionScript}
          handLuggageLabel={handLuggageLabel}
          checkinLabel={checkinLabel}
          scrollIntoView={scrollIntoView}
          setToState={setToState}
          amountShown={amountShown}
          itemNumber={index + 1}
          refProp={isLastItem ? lastItemElement : null}
        />
      )
    })

    let oldItems = ""
    let newItems = ""

    let adjustedIncreaseAmount = increaseAmount
    const sizeDiff = allItems.length - amountShown
    if (sizeDiff < 0) {
      adjustedIncreaseAmount = increaseAmount - Math.abs(sizeDiff)
    }

    const index = mappedItems.length - adjustedIncreaseAmount
    oldItems = mappedItems.slice(0, index)
    newItems = mappedItems.slice(index)

    return (
      <React.Fragment>
        {oldItems}
        <div className={mappedItems.length <= initialAmount ? "" : "next-items-wrapper"}>{newItems}</div>
      </React.Fragment>
    )
  }
  return null
}

class Item extends Component {
  handleAccordion = (event, classname, item) => {
    let elem = event.currentTarget
    this.showHideContent(elem, classname)
  }

  showHideContent = (elem, classname) => {
    elem.__toggle = !elem.__toggle
    let parent = elem.parentElement
    let target = parent.querySelector(classname)
    if (elem.__toggle) {
      target.style.height = target.scrollHeight + "px"
      parent.classList.add("is-active")
    } else {
      target.style.height = 0 + "px"
      parent.classList.remove("is-active")
    }
  }

  componentDidMount() {
    const hash = this.props.hash
    if (hash) {
      this.handleHash(hash)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.hash !== this.props.hash) {
      if (this.props.hash) {
        this.handleHash(this.props.hash)
      }
    }
  }

  handleHash(hash) {
    if (this.props.item.anchorId && hash === this.props.item.anchorId) {
      // waits until paint is done
      requestAnimationFrame(() => {
        this.openAccordionFromAnchor()
      })
    }
    if (this.props.setToState) {
      this.props.setToState({ hash: "" })
    }
  }

  openAccordionFromAnchor = () => {
    const accordion = document.getElementById(this.props.item.anchorId)
    const accordionTrigger = accordion.querySelector(".itemtable")
    if (accordionTrigger) {
      if (!accordionTrigger.classList.contains("is-active")) this.showHideContent(accordionTrigger, ".contentWrapper")

      if (this.props.scrollIntoView) this.props.scrollIntoView(accordion)
    }
  }

  handleTouchStart = (target) => {
    let parent = target.parentElement
    parent.classList.add("touched")
  }

  handleTouchEnd = (target) => {
    let parent = target.parentElement
    parent.classList.remove("touched")
  }

  render() {
    const { item } = this.props
    return (
      <div
        ref={this.props.refProp}
        id={item.anchorId}
        className={`item-list-item ${this.props.itemNumber > this.props.amountShown ? "is-hidden" : ""}${" " + this.props.itemNumber}`}
      >
        <div className={`button itemtable ${item.info ? "" : "no-info"}`}>
          <div
            className="iteminfo"
            onClick={item.info ? (e) => this.handleAccordion(e, ".contentWrapper", item) : undefined}
            onTouchStart={(e) => this.handleTouchStart(e.currentTarget)}
            onTouchEnd={(e) => this.handleTouchEnd(e.currentTarget)}
          >
            <div className="title" dangerouslySetInnerHTML={{ __html: item.title }}></div>
            <div className="checkin">
              <Svg iconName={item.checkinLogo} fillColor={item.checkinLogoColor} stroke={"#FFF"} />
              <span>{this.props.checkinLabel}</span>
            </div>
            <div className="handLuggage">
              <Svg iconName={item.handLuggageLogo} fillColor={item.handLuggageLogoColor} stroke={"#FFF"} />
              <span>{this.props.handLuggageLabel}</span>
            </div>
          </div>
          {item.info ? (
            <div className="contentWrapper show-hide">
              <span className="info-text" dangerouslySetInnerHTML={{ __html: item.info }}></span>
              {this.props.mopinionScript ? htmlStringToReactElement(this.props.mopinionScript) : ""}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    )
  }
}
